import { useCallback, useState } from 'react';
import useApiCall from '../../../../../hooks/useApiCall';
import PassengersService from '../../../../../services/affreightment/PassengersService';
import { useAppContext } from '../../../../../contexts/auth';
import { toast } from 'react-toastify';

interface UseDeletePassengerInterface {
  getPassengers: (workplaceCode: number) => void;
  workplaceCode: number;
  isReactivateDateSet: boolean;
  reactivateDate: string;
  inactivatePassengerCode: string | number;
}

export default function useDeletePassenger({ getPassengers, workplaceCode, isReactivateDateSet, reactivateDate, inactivatePassengerCode }: UseDeletePassengerInterface) {
  const [isInactivating, setIsInactivating] = useState(false);

  const { apiCall } = useApiCall();
  const { selectedCompany, userData } = useAppContext();
  const companyCode = selectedCompany.value;
  const { userCode, userProfile } = userData;

  const currentDate = new Date().toJSON().slice(0, 10);

  const handleInactivatePassenger = useCallback(async () => {
    await apiCall({
      apiToCall: PassengersService.editPassenger,
      queryParams: {
        codFuncionario: inactivatePassengerCode,
        ativado: false,
        provisorio: isReactivateDateSet ? true : false,
        dataInativoAte: isReactivateDateSet ? reactivateDate : currentDate,
        codEmpresa: companyCode,
        codUsu: userCode,
        perfilUsu: userProfile,
      },
      onStartLoad: () => setIsInactivating(true),
      onEndLoad: () => setIsInactivating(false),
      actionAfterResponse: (response) => {
        if (!response.codigo) {
          toast.error(`Não foi possível deletar o passageiro. Por favor, tente novamente (${response.msg})`);
          return;
        }
        toast.success('Passageiro removido com sucesso!');
        getPassengers(workplaceCode);
      },
      catchMessage: 'Não foi possível remover o passageiro, Por favor, tente novamente',
    });
  }, [apiCall, companyCode, currentDate, getPassengers, inactivatePassengerCode, isReactivateDateSet, reactivateDate, userCode, userProfile, workplaceCode]);

  return {
    isInactivating,
    handleInactivatePassenger,
  };
}
